/**
 * El .prn de BAC usa Latin-1/Windows-1252 (tildes y Ñ en un solo byte) — si se arma el Blob
 * directo desde el string de JS, el navegador lo codifica como UTF-8 y esos caracteres salen
 * mal en el archivo. Se convierte cada char code a su byte Latin-1 antes de descargar.
 */
function aBytesLatin1(texto: string): Uint8Array {
  const bytes = new Uint8Array(texto.length);
  for (let i = 0; i < texto.length; i++) bytes[i] = texto.charCodeAt(i) & 0xff;
  return bytes;
}

/** Descarga un archivo de texto. `comoLatin1` para el .prn de BAC; el CSV va en UTF-8. */
export function descargarArchivoTexto(
  contenido: string,
  nombreArchivo: string,
  comoLatin1: boolean,
): void {
  const partes: BlobPart[] = comoLatin1 ? [aBytesLatin1(contenido) as BlobPart] : [contenido];
  const blob = new Blob(partes, { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  a.click();
  URL.revokeObjectURL(url);
}
